<template>
  <div class="text-start">

    <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'venues'}">venues</router-link>
            <span class="mx-2">/</span>
            <span>New venue</span>
          </div>
          <div class="text-xl">
            New venue
          </div>
        </div>
      </div>
    </nav>
    <div class="py-4">
      <div class="">
        <UpdateOrCreateVenueComponent/>
      </div>
    </div>
  </div>
</template>
<script>
import UpdateOrCreateVenueComponent from "../../components/UpdateOrCreateVenueComponent";

export default {
  name: "CreateVenue",
  components: {UpdateOrCreateVenueComponent},
  data() {
    return {
      name: null,
      phone_number: null,
      address: null,
      email: null,
      custom_splash_url: null,
      success_url: null,
      more_info: null,
      loading: false,
      errors: []
    }
  },

  mounted() {
    this.$root.$on("venue_created", () => {
      this.$router.push({ message: 'venues' });
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    }
  }
}
</script>
<style scoped>
</style>